import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, input } from '@angular/core';

import { AppSharedModule } from 'app/app-shared.module';
import {
  EnableClassTelemetry,
  EnableComponentTelemetry,
  injectComponentTelemetryService,
} from 'app/services/otel.service';

import SidePaneItem from '../dashboard-side-pane/SidePaneItem';
import { SavedView } from '../../models/saved-view.model';

@EnableClassTelemetry()
@Component({
  selector: 'app-saved-view-side-pane-item',
  imports: [AppSharedModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './saved-view-side-pane-item.component.html',
  styleUrls: ['./saved-view-side-pane-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SavedViewSidePaneItemComponent extends SidePaneItem<SavedView> {
  @EnableComponentTelemetry() otelService = injectComponentTelemetryService();

  // eslint-disable-next-line
  savedView = input.required<SavedView>({ alias: 'item' });

  itemType = 'savedView';

  onLoadClicked(): void {
    if (this.isDisabled) {
      return;
    }

    this.itemAction.emit({ action: 'load' });
  }

  onMenuAction(action: string): void {
    if (this.isDisabled) {
      return;
    }

    this.itemAction.emit({ action });
  }

  get item(): SavedView {
    return this.savedView();
  }
}
